import React from 'react';
import styled from 'styled-components';
import {InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import ServiceCard from '../Components/ServiceCard';
import design from '../img/design.svg';
import intelligence from '../img/intelligence.svg';
import gamedev from '../img/game-dev.svg';

function ServicesSection() {
    return (
        <InnerLayout>
            <ServicesSectionStyled>
                <Title title={'Services'} span={'services'} />
                <div className="services">
                    <div className="mid-card">
                        <ServiceCard 
                            image={intelligence} 
                            title={'Backend Developer'} 
                            paragraph={'Hands on experience with python backend frameworks like Django, fastapi and flask with AWS, also exposure to Devops tools like Docker and Jenkins'}
                        />
                    </div>
                    <ServiceCard 
                        image={design} 
                        title={'AI Engineer'} 
                        paragraph={'Experience with transformers, nlp and LLM models,  Working familiarity and practical experience with llm finetuning ,prompt engineering with langchain and opencv'}
                    />
                </div>
            </ServicesSectionStyled>
        </InnerLayout>
    )
}

const ServicesSectionStyled = styled.section`
    .services{
        margin-top: 5rem;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 1.5rem;
        @media screen and (max-width:1000px){
            flex-direction: column;
        }
        @media screen and (max-width:950px){
            grid-template-columns: repeat(2, 1fr);
        }
        @media screen and (max-width:650px){
            grid-template-columns: repeat(1, 1fr);
        }
       
    }
`;

export default ServicesSection;
